import React from 'react';
import { DashboardLayout } from '../components/dashboard';
import { WorkflowDashboard } from '../components/workflow/WorkflowDashboard';

export const PendingEntriesPage: React.FC = () => {
  return (
    <DashboardLayout>
      <WorkflowDashboard />
    </DashboardLayout>
  );
};
